import customFetch from "./fetch";
import axios from "./axios";

// interfaces
import { ISpaceFull } from "@/types/Space";
import { ICalculatePrice } from "@/types/api/CalculatePrice";

// helpers
import API_ROUTES from "./routes.constant";
import { pathToUrl } from "./query/reactQuery/pathToUrl";
import { buildUrl } from "./helpers";

export default {
  async getSpace(slug: string, params?: Record<string, unknown>) {
    const { preview, ...restParams } = params || {};

    const fetchKey = slug ? pathToUrl(API_ROUTES.spacesUrls.spaceSingle, { slug }) : null;
    const fetchKeyPreview = slug ? pathToUrl(API_ROUTES.previewUrls.previewSpace, { slug }) : null;
    
    return await customFetch(
      buildUrl((preview ? fetchKeyPreview : fetchKey) as string, restParams),
      {
        headers: {
          "LOCATION-AUTH": preview && `Bearer ${preview}`,
        } as unknown as HeadersInit,
      }
    ) as ISpaceFull;
  },

  publishSpace(slug: string, data?: unknown) {
    return axios.put(`/spaces/${slug}/publish`, data);
  },

  async convertOptionToBooking(slug: string, activityId: string | number) {
    const res = await axios.patch(`/spaces/${slug}/calendar/${activityId}`, { sort: "booking" });
  
    return res.data;
  },

  async postCalculatePrice(data: unknown) {
    const res = await axios.post(API_ROUTES.calculatePrice, data);
  
    return res.data as ICalculatePrice;
  },

  async getSpaceAxios(slug: string, params?: Record<string, unknown>) {
    const fetchKey = slug ? pathToUrl(API_ROUTES.spacesUrls.spaceSingle, { slug }) : null;

    const res = await axios.get(buildUrl(fetchKey || "", params));
  
    return res.data as ISpaceFull;
  },

  async getSpaceRecordPageView(slug: string) {
    const fetchKey = slug ? pathToUrl(API_ROUTES.spacesUrls.spaceRecordPageView, { slug }) : null;

    return axios.get(fetchKey || "");
  }
};
